// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1b21G","selects":"Documents_selects__2-1Vx"};